import isObject from "lodash/isObject";
import negate from "lodash/negate";

export interface IRow {
    value: string;
    text: string;
    withCount?: boolean;
    withText?: boolean;
}

export const isRow = (candidate: any): candidate is IRow => {
    if (isObject(candidate)) {
        const hasValue = !!(<any>candidate).value;
        const hasText = !!(<any>candidate).text;

        return hasValue && hasText;
    }
    return false;
};

export const isRowList = (candidate: any): candidate is IRow[] => {
    if (Array.isArray(candidate)) {
        return !candidate.some(negate(isRow));
    }
    return false;
}
